import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  products: [],
  loading: false,
  error: null,
  pageNumber: 0,
  totalCount: 0,
  categoryName: '',
  initial: true,
  categoryId: '',
};

const ProductListingPage = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.PRODUCT_LISTING_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.PRODUCT_LISTING_SUCCESS:
      return {
        ...state,
        products: [...payload.products],
        // categoryId: payload.categoryId,
        totalCount: payload.totalCount,
        categoryName: payload.categoryName,
        loading: false,
        initial: false,
      };
    case actions.PRODUCT_LISTING_UPDATE:
      return {
        ...state,
        loading: false,
        products: [...state.products, ...payload.products],
      };
    case actions.PRODUCT_LISTING_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.PRODUCT_LISTING_RESET:
      return {
        ...INITIAL_STATE,
      };
    case actions.PRODUCT_SET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: state.pageNumber + 1,
      };
    case actions.PRODUCT_RESET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: 0,
      };

    case actions.SET_CATEGORY_ID:
      return {
        ...state,
        categoryId: payload,
      };
    default:
      return state;
  }
};

export default ProductListingPage;
